<template>
  <div id="app">
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <router-view class="mainRouter"></router-view>
    </transition>
    <div class="footer">
      <p>中国田径协会©版权所有 <a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备18040857号-1</a></p>
    </div>
  </div>
</template>

<script>
export default {
  // watch: {
  //   '$route' (to, from) //监听路由，获取上一个路由信息
  //   {

  //   }
  // },
  name: "App",
};
</script>
<style scoped>
.footer {
  padding: 12px 0;
  line-height: 26px;
  text-align: center;
  background: #ee1d23;
  max-width: 1560px;
  margin: 0 auto;
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  right: 0;
  z-index:999;
}
.footer,
.footer p,
.footer p a {
  color: #fff;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue